import React from 'react';
import { FileText, Eye, Download, RefreshCw, Upload, Loader2 } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Card, Chip, EmptyState, fmtDate, fileTypeOf } from './drawerShared';

export const ResumeCard = ({ candidate, canEdit, uploading, onPickFile, onView, onDownload, compact = false, testId }) => {
  const has = !!candidate.resume_file_key;
  const type = fileTypeOf(candidate.resume_file_name);
  const uploadBtn = canEdit && (
    <Button size="sm" variant={has ? 'outline' : 'default'} className="h-8 gap-1.5 text-xs" disabled={uploading} onClick={onPickFile} data-testid="drawer-resume-upload-btn">
      {uploading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : has ? <RefreshCw className="h-3.5 w-3.5" /> : <Upload className="h-3.5 w-3.5" />}
      {has ? 'Replace' : 'Upload Resume'}
    </Button>
  );
  return (
    <Card title="Resume" icon={FileText} action={has ? uploadBtn : null} data-testid={testId || 'drawer-resume-section'}>
      {has ? (
        <div className={`flex ${compact ? 'flex-col gap-3' : 'flex-col gap-4 md:flex-row md:items-center md:justify-between'}`}>
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-500 ring-1 ring-slate-200">
              <FileText className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <p className="truncate text-sm font-semibold text-slate-900" title={candidate.resume_file_name} data-testid="resume-file-name">{candidate.resume_file_name || 'Resume'}</p>
              <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-slate-500">
                {type && <Chip tone="bg-blue-50 text-blue-700" data-testid="resume-file-type">{type}</Chip>}
                <span data-testid="resume-uploaded-at">Uploaded {fmtDate(candidate.resume_uploaded_at)}</span>
                {candidate.resume_uploaded_by_name && <span>· by {candidate.resume_uploaded_by_name}</span>}
              </div>
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <Button variant="outline" size="sm" className="h-8 gap-1.5 text-xs" onClick={onView} data-testid="drawer-resume-download-btn">
              <Eye className="h-3.5 w-3.5" /> View
            </Button>
            <Button variant="ghost" size="sm" className="h-8 gap-1.5 text-xs" onClick={onDownload} data-testid="drawer-resume-save-btn">
              <Download className="h-3.5 w-3.5" /> Download
            </Button>
          </div>
        </div>
      ) : (
        <EmptyState icon={FileText} title="No resume uploaded" hint="PDF, DOC or DOCX · up to 10 MB." action={uploadBtn} testId="drawer-no-resume" />
      )}
      {has && <p className="mt-3 text-[11px] text-slate-400">PDF / DOC / DOCX · max 10 MB · replacing keeps the previous file in storage for audit.</p>}
    </Card>
  );
};

export const DocumentsTab = (props) => (
  <div className="space-y-4" data-testid="tab-panel-documents">
    <ResumeCard {...props} />
  </div>
);
